import { styled } from '@mui/material/styles';
import LoginBgImg from '@/assets/loginBg.png';
import LoginLogoImg from '@/assets/loginLogo.png';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button/Button';
import { useAppLogout } from '@/hooks/useAppLogout';
import { useNavigate } from 'react-router';

const UnauthorizedPage = () => {
  const handleLogout = useAppLogout();
  const navigate = useNavigate();

  const handleHomePage = () => {
    navigate('/');
  };

  return (
    <Root>
      <Modal>
        <ModalHeader>
          <Logo src={LoginLogoImg} alt="Partner Portal Logo" />
        </ModalHeader>
        <ModalBody>
          <Header>
            <FormattedMessage
              id="unauthorizedHeader"
              defaultMessage="You are unauthorized"
            />
          </Header>
          <Subheader>
            <FormattedMessage
              id="unauthorizedSubheader"
              defaultMessage="You don't have access to that page. Please contact your account manager for more information."
            />
          </Subheader>
          <Actions>
            <Button
              variant="outlined"
              onClick={() => handleLogout()}
              aria-label="Logout Button"
            >
              <FormattedMessage id="logout" defaultMessage="Logout" />
            </Button>
            <Button
              variant="contained"
              onClick={handleHomePage}
              aria-label="Home Page Button"
            >
              <FormattedMessage
                id="homePage"
                defaultMessage="Home Page"
              />
            </Button>
          </Actions>
        </ModalBody>
      </Modal>
    </Root>
  );
};

const Root = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: `url(${LoginBgImg}) no-repeat center center`,
  backgroundSize: 'cover',
});

const Modal = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '540px',
  left: '50%',
  color: theme.palette.textPrimaryWhite,
  transform: 'translateX(-50%)',
  top: '20%',
  borderRadius: 8,
  overflow: 'hidden',
  boxShadow: '0px 4px 10px 0px #00000066',
}));

const ModalHeader = styled('div')({
  background: '#E6162680',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '12px 0 12px',
});

const Logo = styled('img')({
  width: 90,
});

const Header = styled('div')({
  fontSize: 24,
  lineHeight: '28px',
  fontWeight: 600,
  marginBottom: 15,
});

const Subheader = styled('div')({
  fontSize: 14,
  lineHeight: '20px',
  fontWeight: 400,
  marginTop: 5,
  marginBottom: 30,
});

const ModalBody = styled('div')(({ theme }) => ({
  background: '#fff',
  padding: '42px 95px',
  display: 'flex',
  textAlign: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  color: theme.palette.textPrimaryBlack,
}));

const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '100%',
  justifyContent: 'center',
}));

export default UnauthorizedPage;
